// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../../../../css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, "._19bvqslr{padding-left:22px}\n._ca0qqslr{padding-top:22px}\n._n3tdutpp{padding-bottom:var(--ds-space-150,9pt)}\n._u5f3qslr{padding-right:22px}", ""]);
// Exports
module.exports = exports;
